const { toInt, toString } = require('@/functions/transform');

class WaiverFormMinor {
    constructor() {
        /**
         * @type {Number}
         */
        this.ID = null;

        /**
         * @type {Number}
         */
        this.age = null;

        /**
         * @type {string}
         */
        this.firstName = '';

        /**
         * @type {string}
         */
        this.lastName = '';
    }

    getHydrationMap() {
        return {
            ID: toInt,
            age: toInt,
            firstName: toString,
            lastName: toString,
        };
    }
}

module.exports = WaiverFormMinor;
